<template>
  <div>
    <div class="md-layout" v-bind:style="style_list()">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>{{icone_title}}</md-icon>
            </div>
            <h4 class="title" v-html="title"></h4>
          </md-card-header>
          <md-card-content>
            <!-- Filtro -->
            <div class="md-layout mb-20">
              <div class="md-layout-item md-size-20 md-small-size-45 md-xsmall-size-100">
                <md-field>
                  <!-- :input="datepicker_inputchanged" -->
                  <datepicker
                    format="dd/MM/yyyy"
                    :typeable="true"
                    inputClass="md-input"
                    name="filtro_data_inicio"
                    v-model="data_inicio"
                    :language="language_date"
                    calendar-button-icon-content="event"
                    :input="datepicker_inputchanged"
                    placeholder="Data Início"
                  ></datepicker>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20 md-small-size-45 md-xsmall-size-100">
                <md-field>
                  <!-- :input="datepicker_inputchanged" -->
                  <datepicker
                    format="dd/MM/yyyy"
                    :typeable="true"
                    inputClass="md-input"
                    name="filtro_data_fim"
                    v-model="data_fim"
                    :language="language_date"
                    calendar-button-icon-content="event"
                    :input="datepicker_inputchanged"
                    placeholder="Data Fim"
                  ></datepicker>
                </md-field>
              </div>
              <div class="md-layout-item md-size-40 md-small-size-45 md-xsmall-size-100">
                <md-field>
                  <md-select v-model="id_estabelecimento">
                    <md-option :value="-1">--TODAS UNIDADES--</md-option>
                    <md-option
                      v-for="(item,index) in list_unidades"
                      :key="index"
                      :value="item.id"
                    >{{item.nome}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-5 md-small-size-10 md-xsmall-size-100">
                <md-button
                  title="Adicionar"
                  class="md-round md-just-icon md-success"
                  v-on:click="search"
                  :disabled="carregando"
                  type="button"
                >
                  <md-icon>search</md-icon>
                </md-button>
              </div>
            </div>

            <!-- Carregando -->
            <div v-if="carregando" class="box-carregando">
              <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate"></md-progress-spinner>
            </div>

            <md-table
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover table-custom"
            >
              <md-table-toolbar v-if="false">
                <md-field>
                  <md-input
                    type="search"
                    class="mb-6"
                    clearable
                    style="width: 400px"
                    placeholder="Pesquisar"
                    v-model="searchQuery"
                    @keyup.enter="enter"
                  ></md-input>
                </md-field>
                <md-field>
                  <label for="pages">Exibir por {{Termos.Pagina}}:</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >{{ item }}</md-option>
                  </md-select>
                </md-field>
                <md-button
                  title="Adicionar"
                  class="md-round md-just-icon md-info pull-right"
                  v-on:click="add_new"
                  type="button"
                >
                  <md-icon>add</md-icon>
                </md-button>
              </md-table-toolbar>

              <md-table-empty-state
                v-if="!carregando"
                md-label="Registros não localizados"
                md-description="Não há dados para o período pesquisado"
              ></md-table-empty-state>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label class="td-btn">
                  <md-button
                    class="md-just-icon md-primary md-left-table"
                    @click.native="visualizar(item)"
                  >
                    <md-icon>remove_red_eye</md-icon>
                  </md-button>
                </md-table-cell>
                <md-table-cell v-if="false" md-label="ID" md-sort-by="id">{{item.id}}</md-table-cell>
                <md-table-cell
                  v-if="false"
                  md-label="Check List"
                  md-sort-by="nome_checklist"
                >{{item.nome_checklist}}</md-table-cell>
                <md-table-cell
                  v-if="false"
                  md-label="Referência"
                  md-sort-by="referencia"
                >{{item.referencia}}</md-table-cell>
                <md-table-cell
                  v-if="false"
                  md-label="Cliente"
                  md-sort-by="nome_cliente"
                >{{item.nome_cliente}}</md-table-cell>
                <md-table-cell md-label="Data" md-sort-by="data">{{item.data | date_show}}</md-table-cell>
                <md-table-cell class="td-big"
                  md-label="Unidade"
                  md-sort-by="nome_estabelecimento"
                >{{item.nome_estabelecimento}}</md-table-cell>
                <md-table-cell
                  md-label="Resp. Controlare"
                  md-sort-by="nome_responsavel"
                >{{item.nome_responsavel}}</md-table-cell>
                <md-table-cell
                  md-label="Resp. Local"
                  md-sort-by="responsavel_local"
                >{{item.responsavel_local}}</md-table-cell>
                <md-table-cell
                  md-label="Resultado"
                  md-sort-by="nota_final"
                  class="text-center"
                >{{item.nota_final | nota_final_show}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>

          <md-card-actions md-alignment="space-between">
            <p
              class="card-category"
            >Mostrando {{ from + 1 }} {{Termos.Ate}} {{ to }} de {{ total }} resultados</p>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>

    <div v-if="action =='form'">
      <inspecao_form
        v-bind:id_load="form.id"
        v-bind:onSave="onSave"
        show_back_button="true"
        v-bind:onBack="onBack"
      ></inspecao_form>
    </div>
    <div v-if="action =='ver'">
      <inspecao_visualizar
        v-bind:cliente_oculto="cliente_oculto"
        v-bind:id_load="form.id"
        v-bind:onSave="onSave"
        show_back_button="true"
        v-bind:onBack="onBack"
      ></inspecao_visualizar>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import swal from "sweetalert2";
import service from "../../../services/InspecaoService";
import inspecao_form from "./Form";
import inspecao_visualizar from "./Visualizar";
import impTermos from "../../../library/Termos";
import Util from "../../../library/Util";
import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";
import serviceEstabelecimento from "../../../services/EstabelecimentoService";
import serviceUsuario from "../../../services/UsuarioService";

export default {
  components: {
    Pagination,
    inspecao_form,
    Datepicker,
    inspecao_visualizar
  },
  props: ["cliente_oculto"],
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      currentSort: "data",
      currentSortOrder: "desc",
      carregando: true,
      pagination: {
        perPage: 6,
        currentPage: 1,
        perPageOptions: [6, 10, 25, 50],
        total: 0
      },
      footerTable: ["Nome", "Email", "Perfil"],
      searchQuery: "",
      propsToSearch: ["name", "email", "perfil"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      action: "list",
      form: null,
      Termos: impTermos,
      language_date: ptBR,
      title: "Relatório de auditoria técnica",
      icone_title: "assignment",
      data_inicio: null,
      data_fim: null,

      id_estabelecimento: -1,
      list_unidades: []
    };
  },
  methods: {
    datepicker_inputchanged(obj) {
      console.log(obj);
    },

    style_list() {
      if (this.action == "form" || this.action == "ver") {
        return "display:none";
      }
      return "";
    },
    customSort(value) {
      // console.log(  this.currentSort +" - " +  this.currentSortOrder );
      this.load_data();
    },
    handleLike(item) {
      this.form = item;
      this.action = "form";
    },
    visualizar(item) {
      this.form = item;
      this.action = "ver";
    },

    onBack(objPost) {
      //Clicou no back button.
      this.form = null; //Voltando para a lista
      this.action = "list";
      this.clean_back_button();
    },
    onSave() {
      this.load_data();
    },
    handleEdit(item) {
      this.form = item;
      this.action = "form";
    },
    add_new(e) {
      e.preventDefault();
      this.form = service.getModel();
      this.action = "form";
    },
    search() {
      this.load_data();
    },
    load_data() {
      let self = this;
      self.carregando = true;

      var query = this.searchQuery;

      var data = {};

      if (this.data_inicio != null) {
        data["data_inicio"] = Util.dateToBd(this.data_inicio);
      }

      if (this.data_fim != null) {
        data["data_fim"] = Util.dateToBd(this.data_fim);
      }

      if (this.id_estabelecimento > -1) {
        data["id_estabelecimento"] = this.id_estabelecimento;
      }

      if (
        this.cliente_oculto != null &&
        this.cliente_oculto != undefined &&
        this.cliente_oculto.toString() == "1"
      ) {
        data["cliente_oculto"] = this.cliente_oculto;
        this.title = "Auditoria cliente oculto";
        this.icone_title = "people_outline";
      }

      service
        .getListCliente(data, this.currentSort, this.currentSortOrder)
        .then(function(response) {
          self.tableData = response.data.data;
          self.carregando = false;

          self.data_inicio = new Date(
            Util.ApiDateToJavascript(response.data.data_inicio)
          );
          self.data_fim = new Date(
            Util.ApiDateToJavascript(response.data.data_fim)
          );
        });
    },
    enter(e) {
      e.preventDefault();

      this.load_data();
    },
    clean_back_button() {
      this.$store.dispatch("setButtonBack", {
        in_form: false,
        rota: "inspecao",
        exibe: false,
        onBack: null
      });
    }
  },
  mounted() {
    
    var pageSize = serviceUsuario.getPageSize();
    this.pagination.perPage = pageSize;
    console.log("pageSize?", pageSize);


    var self = this;

    serviceEstabelecimento.getList("", "nome", "asc").then(function(result) {
      self.list_unidades = result.data;
    });

    this.load_data();
  }
};
</script>
